const readMoreDetailsLinks = document.querySelectorAll('.coach__course');

[...readMoreDetailsLinks].forEach((readMoreLink) => {
    readMoreLink.addEventListener('click', () => {
        if (readMoreLink.classList.contains('active')) {
            readMoreLink.classList.remove('active');
        } else {
            readMoreLink.classList.add('active');
        }
    });
});
